// extracted by mini-css-extract-plugin
module.exports = {"EventOverview":"EventOverview__2S5BO","EventOverview_card":"EventOverview_card__2S5BO","EventOverview_pagination":"EventOverview_pagination__2S5BO"};